module.exports = __webpack_public_path__ + "img/solution--patient-recovery-improved-experience.53816fb2.png";